/**
 * token在Cookie中存储的天数，默认1天
 */
export const COOKIE_EXPIRES = 999
/**
 * token的名字
 */
export const TOKEN_KEY = window.baseConfig.tokenName


export const PAGE_PARAMS = [{
  page: '/yxfx/dbfx',
  params: [{
    label: 'KPI组',
    value: 'kpiClass',
  },
  {
    label: '左侧计量点树',
    value: 'treeData',
  }
  ]
}]

/**
 * 采集编码分类
 */
export const CODE_TYPE_DATA = [{
  type: 'current',
  label: '电流',
  unit: 'A',
  codeData: [{
    code: '207',
    label: '电流A'
  },
  {
    code: '208',
    label: '电流B'
  },
  {
    code: '209',
    label: '电流C'
  },
  {
    code: '210',
    label: '零序电流'
  },
  ]
},
{
  type: 'voltage',
  label: '电压',
  unit: 'V',
  codeData: [{
    code: '201',
    label: '电压A'
  },
  {
    code: '202',
    label: '电压B'
  },
  {
    code: '203',
    label: '电压C'
  }
  ]
},
{
  type: 'power',
  label: '功率',
  unit: 'kw',
  codeData: []
},
]

/**
 * 时间类型分类
 */
export const TIME_TYPE_DATA = [{
  type: 'day',
  label: '日'
},
{
  type: 'week',
  label: '周'
},
{
  type: 'month',
  label: '月'
},
{
  type: 'year',
  label: '年'
},
{
  type: 'timeInterval',
  label: '时段'
},
]

export const TAB_MAP = {
  voltage: '电压(V)', current: '电流(A)',
  power: "功率", factor: '功率因数', frequency: '频率(Hz)',
  ele: '用电量(kWh)', loadRate: '负荷率(%)', imbalance: '不平衡度(%)'
  , water: '水量(m³)', forwardFlow: '正向流量(m³)', reverseFlow: '反向流量(m³)'
  , density: '密度(kg/m³)'
  , currentSpeed: '流速(m³/s)'
  , pressure: '压力(KPa)'
  , temperature: '温度(℃)'
  , abcTemperature: '绕组温度(℃)'
  , abcTemperature2: '触头温度(℃)'
  , tableCode: '表码(kWh)'
  , humidity: '湿度',
  smokeSensation: "烟感",
  load: "负载率(%)",
  concentration: "浓度(ppm)",
  flowCode: "累计流量",
  production: '产量',
  consumption: '单耗'
  //     flowCode: "流量表码"
}
export const TAB_UNIT_MAP = {
  voltage: 'V', current: 'A',
  power: "kW", factor: '', frequency: 'Hz',
  ele: 'kWh', loadRate: '%', imbalance: '%', water: 'm³', forwardFlow: 'm³', reverseFlow: 'm³'
  , density: 'kg/m³'
  , currentSpeed: 'm³/s'
  , pressure: 'KPa'
  , temperature: '℃'
  , abcTemperature: '℃'
  , abcTemperature2: '℃'
  , humidity: ''
  , tableCode: 'kWh',
  smokeSensation: '',
  load: "%",
  concentration: "ppm",
  flowCode: "",
  production: '',
  consumption: ''
}
